
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/we-value-time",
      function () {
        return require("private-next-pages/about-us/we-value-time/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/we-value-time"])
      });
    }
  